// extracted by mini-css-extract-plugin
export default {"primaryTextLabel":"bNrfx","looksProductTextLabel":"jYi5b","oosLabelText":"jwe_q"};